import Swiper, { Navigation, Pagination } from 'swiper'

const SwiperArtists = function () {
  Swiper.use(Navigation, Pagination);

  const artistContainer = document.querySelector('.artist-swiper-container');

  if (artistContainer) {
    const artistSwiper = new Swiper('.artist-swiper', {
      direction: 'horizontal',
      spaceBetween: 15,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      centeredSlides: true,
      initialSlide: 0,
      loop: true,
      preventClicks: true,
      pagination: {
        el: document.querySelector('.sw-artist'),
        clickable: true
      },
      navigation: {
        nextEl: artistContainer.querySelector('.swiper-button-next'),
        prevEl: artistContainer.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        992: {
          spaceBetween: 5,
          allowTouchMove: false
        }
      }
    })
  }
}

export default SwiperArtists;